module.exports = __webpack_public_path__ + "img/appointment.a9fedd2e.png";